import React from 'react'
import { HeaderContent } from '../styles'

import { Field } from '../../../../components/Input/CheckboxInput/styles'
import { ButtonIcon } from '../../../../components/Table/TableActions/styles'
import { Row } from '../../../../components/commons'
import { FaChevronUp, FaChevronDown } from 'react-icons/fa'
import { useTheme } from 'styled-components'

export interface ListItemProps {
  column: any
  index: number
  isActive: boolean
  onSelectAllValues: (check: boolean) => void
  onSubmitOrder: (name: string, order: string) => void
}

const HeaderTable: React.FunctionComponent<ListItemProps> = ({
  column,
  index,
  onSubmitOrder,
  onSelectAllValues,
  isActive,
}) => {
  const [order, setOrder] = React.useState('asc')

  const theme: any = useTheme()

  React.useEffect(() => {
    onSubmitOrder(column.sort, order)
  }, [order])

  return (
    <div
      key={column._id}
      style={{
        display: 'inline-block',
        paddingRight: 15,
        width: index === 0 ? '30%' : index === 1 ? '10%' : index === 2 ? '30%' : '20%',
      }}
    >
      <Row
        style={{
          justifyContent: 'center',
          gap: 15,
        }}
      >
        {index === 0 && isActive && (
          <Field type='checkbox' onChange={(e) => onSelectAllValues(e.target.checked)} />
        )}
        <HeaderContent.BreadName>{column.name}</HeaderContent.BreadName>
        <ButtonIcon onClick={() => setOrder((old) => (old === 'asc' ? 'desc' : 'asc'))}>
          {order === 'asc' ? (
            <FaChevronUp size={20} color={theme.colors.primary} />
          ) : (
            <FaChevronDown size={20} color={theme.colors.primary} />
          )}
        </ButtonIcon>
      </Row>
    </div>
  )
}

export default HeaderTable
